import { compact } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikSelect, FormikSelectProps } from 'components';
import { TIME_INTERVAL_MINUTES } from 'constants/time-interval.constants';
import { TranslationNamespace } from 'i18n';

type Props = Omit<FormikSelectProps, 'options'> &
  Partial<Pick<FormikSelectProps, 'options'>>;

export const TimeIntervalSelect: React.FC<Props> = ({
  options: optionsProp,
  required,
  ...rest
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'intervals',
  });

  const options = useMemo(
    () =>
      optionsProp ||
      compact([
        !required && { value: '0', label: t('permanent') },
        {
          value: String(TIME_INTERVAL_MINUTES.THIRTY_MINUTES),
          label: t('30_minutes'),
        },
        {
          value: String(TIME_INTERVAL_MINUTES.ONE_HOUR),
          label: t('1_hour'),
        },
        {
          value: String(TIME_INTERVAL_MINUTES.SIX_HOURS),
          label: t('6_hours'),
        },
        {
          value: String(TIME_INTERVAL_MINUTES.TWELVE_HOURS),
          label: t('12_hours'),
        },
        {
          value: String(TIME_INTERVAL_MINUTES.ONE_DAY),
          label: t('24_hours'),
        },
      ]),
    [optionsProp, required, t],
  );

  return (
    <FormikSelect
      size="small"
      {...rest}
      required={required}
      options={options}
    />
  );
};
